export const VIEW_TYPE = {
  DEFAULT: 'DEFAULT',
  STANDARD: 'STANDARD'
};

/**
 * From https://git.hubteam.com/HubSpot/Sales/blob/7bebd16ecfc21243af8e3515360ddaac8e78cd7c/SalesCore/src/main/protobuf/sales.proto#L23 (permalink)
 *
 * Teams should migrate away from negative ids in frontend/listing-lib logic where possible
 * Keeping this mapping allows us to translate them to idLabels as a fallback where necessary
 */
export const DEFAULT_VIEW_ID_TO_ID_LABEL = {
  '-1': 'my',
  '-2': 'all',
  '-3': 'uncontacted',
  '-4': 'recently_assigned',
  '-5': 'my_month',
  '-6': 'closed_month',
  '-7': 'favorites',
  '-8': 'hidden',
  '-9': 'needs_action',
  '-10': 'needs_follow_up',
  '-11': 'unassigned',
  '-12': 'event_overdue',
  '-13': 'event_this_week',
  '-14': 'event_today',
  '-15': 'event_none',
  '-16': 'activity_none',
  '-17': 'activity_recent',
  '-18': 'due_today',
  '-19': 'overdue',
  '-20': 'upcoming',
  '-21': 'most_engaged',
  '-22': 'completed',
  '-23': 'recorded_calls',
  '-24': 'marketing_contacts',
  '-25': 'recently_updated',
  '-26': 'updated_by_me',
  '-27': 'recently_published',
  '-28': 'forecast',
  '-29': 'deal_collaborator',
  '-30': 'voicemails',
  '-31': 'unused',
  '-32': 'recently_deleted',
  '-33': 'drafts',
  '-34': 'published',
  '-35': 'scheduled',
  '-36': 'all_forms',
  '-37': 'forms_with_submissions',
  '-38': 'published_forms',
  '-39': 'non_hubspot_forms',
  '-40': 'all_sms',
  '-41': 'draft_sms',
  '-42': 'schedules_sms',
  '-43': 'sent_sms',
  '-44': 'archived_sms',
  '-45': 'needs_review_workflows',
  '-46': 'invoice_paid_view',
  '-47': 'archived_web_interactives',
  '-48': 'all_emails',
  '-49': 'draft_emails',
  '-50': 'scheduled_emails',
  '-51': 'sent_emails',
  '-52': 'archived_emails',
  '-53': 'ai_generated_emails',
  '-54': 'all_surveys',
  '-55': 'published_surveys',
  '-56': 'draft_surveys',
  '-57': 'inactive_surveys',
  '-58': 'ai_generated_sms',
  '-59': 'archived',
  '-60': 'managed_partner_clients',
  '-61': 'new_records',
  '-62': 'expiring_soon',
  '-63': 'issues_emails',
  '-64': 'deleted_emails',
  '-65': 'export',
  '-66': 'all_linkedin',
  '-67': 'all_whatsapp',
  '-68': 'open',
  '-69': 'target_account',
  '-70': 'not_in_sequence',
  '-71': 'all_my',
  '-72': 'my_campaigns',
  '-73': 'my_tasks',
  '-74': 'no_decision_maker',
  '-75': 'no_open_deals'
};